import { Link, usePage } from '@inertiajs/react'
import { BookOpen, Info, Map } from 'lucide-react'
import { useEffect, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  brandColor?: string
}

interface GuestSharedProps {
  errors: Record<string, string>
}

type Tab = 'guide' | 'map' | 'inside'

function activeTab(url: string): Tab {
  if (url.includes('/map')) return 'map'
  if (url.includes('/inside')) return 'inside'
  return 'guide'
}

function shareTokenFromUrl(url: string): string {
  const match = url.match(/\/g\/([^/]+)/)
  return match ? match[1] : ''
}

const TABS = [
  { id: 'guide' as Tab, label: 'Guide', Icon: BookOpen, path: '' },
  { id: 'map'   as Tab, label: 'Map',   Icon: Map,      path: '/map' },
  { id: 'inside'as Tab, label: 'Inside',Icon: Info,     path: '/inside' },
]

export function GuestLayout({ children, brandColor = '#C2553A' }: Props) {
  const { url } = usePage<GuestSharedProps>()
  const token   = shareTokenFromUrl(url)
  const tab     = activeTab(url)

  useEffect(() => {
    document.documentElement.style.setProperty('--brand', brandColor)
  }, [brandColor])

  return (
    <div className="flex h-dvh flex-col" style={{ background: 'var(--g-bg, #FBF7F1)' }}>
      <main className="flex-1 overflow-y-auto pb-32">
        {children}
      </main>

      {/* Floating pill nav */}
      <nav
        aria-label="Main navigation"
        className="fixed left-1/2 z-50 flex -translate-x-1/2 gap-1 rounded-full px-1.5 py-1.5"
        style={{
          bottom: 'calc(36px + env(safe-area-inset-bottom))',
          background: 'rgba(31, 26, 20, 0.92)',
          backdropFilter: 'blur(18px)',
          WebkitBackdropFilter: 'blur(18px)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
        }}
      >
        {TABS.map(({ id, label, Icon, path }) => {
          const isActive = tab === id
          return (
            <Link
              key={id}
              href={`/g/${token}${path}`}
              aria-current={isActive ? 'page' : undefined}
              className="g-tap flex items-center gap-1.5 rounded-full px-3 py-2 text-xs font-medium transition-all"
              style={{
                background: isActive ? '#FBF7F1' : 'transparent',
                color: isActive ? '#1F1A14' : 'rgba(251, 247, 241, 0.65)',
              }}
            >
              <Icon size={15} aria-hidden="true" />
              {isActive && label}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
